import * as React from "react";
import { Field } from "formik";
import * as Immutable from "immutable";
import ColumnSelect from "./ColumnSelect";
import SelectedColumnsList from "./SelectedColumnsList";
const ColumnsConfiguration = ({
  columnTitle,
  columns,
  createSelectPlaceholder = "Add a column",
  displaySortableListOverlayInPortal = false,
  name
}) => /* @__PURE__ */ React.createElement(Field, { name }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  SelectedColumnsList,
  {
    selectedColumns: value.toArray(),
    columnTitle,
    displayOverlayInPortal: displaySortableListOverlayInPortal,
    onChange: (newColumns) => onChange({ target: { value: Immutable.OrderedSet(newColumns), name } })
  }
), /* @__PURE__ */ React.createElement(
  ColumnSelect,
  {
    id: "column-create-select",
    columnTitle,
    columns,
    onChange: (newColumn) => onChange({ target: { value: Immutable.OrderedSet([...value.toArray(), newColumn]), name } }),
    clearable: false,
    persistSelection: false,
    name: "column-create-select",
    value: void 0,
    excludedColumns: value,
    placeholder: createSelectPlaceholder,
    ariaLabel: createSelectPlaceholder
  }
)));
export default ColumnsConfiguration;
